<template>
  <el-dialog title="编辑出库对接信息"
    :visible.sync="visible"
    width="45%"
    @closed='handleClose'
    :close-on-press-escape="false">
    <el-form :model="appInfo"
      :rules="rules"
      ref="ruleForm"
      label-width="140px">
      <el-form-item label="AppID:">{{appInfo.appId}}</el-form-item>
      <el-form-item label="appKey:">{{appInfo.appKey}}</el-form-item>
      <el-form-item label="ip地址:"
        prop="ip">
        <el-input v-model="appInfo.ip"
          placeholder="多个地址之间用英文逗号分隔"></el-input>
      </el-form-item>
      <el-form-item label="订单完成通知地址:">
        <el-col :span="16"
          style="margin-right:5px">
          <el-form-item label-width="0"
            prop="notifyOrderUrl">
            <el-input v-model="appInfo.notifyOrderUrl"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label-width="0"
            prop="notifyOrderFlag">
            <el-checkbox :disabled="!appInfo.notifyOrderUrl"
              v-model="appInfo.notifyOrderFlag"
              :true-label="1"
              :false-label="0">接收通知</el-checkbox>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="出库单通知地址:">
        <el-col :span="16"
          style="margin-right:5px">
          <el-form-item label-width="0"
            prop="notifyOutstockUrl">
            <el-input v-model="appInfo.notifyOutstockUrl"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label-width="0"
            prop="notifyOutstockFlag">
            <el-checkbox :disabled="!appInfo.notifyOutstockUrl"
              v-model="appInfo.notifyOutstockFlag"
              :true-label="1"
              :false-label="0">接收通知</el-checkbox>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="退货单通知地址:">
        <el-col :span="16"
          style="margin-right:5px">
          <el-form-item label-width="0"
            prop="notifyGoodsReturnUrl">
            <el-input v-model="appInfo.notifyGoodsReturnUrl"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label-width="0"
            prop="notifyGoodsReturnFlag">
            <el-checkbox :disabled="!appInfo.notifyGoodsReturnUrl"
              v-model="appInfo.notifyGoodsReturnFlag"
              :true-label="1"
              :false-label="0">接收通知</el-checkbox>
          </el-form-item>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="toggleModal(false)"
        :loading="loading">取 消</el-button>
      <el-button type="primary"
        @click="handleSubmit"
        :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ent-app-modal',
  components: {},
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    fetch: {
      type: Function
    }
  },
  watch: {
    data: {
      handler (val) {
        this.appInfo = {
          ...this.appInfo,
          ...val
        }
      },
      deep: true
    }
  },
  data () {
    return {
      loading: false,
      visible: false,
      appInfo: {
        appId: '',
        appKey: '',
        ip: '',
        notifyOrderUrl: '',
        notifyOrderFlag: 1,
        notifyOutstockUrl: '',
        notifyOutstockFlag: 1,
        notifyGoodsReturnUrl: '',
        notifyGoodsReturnFlag: 1
      },
      rules: {
        notifyOrderUrl: [
          { type: 'url', message: '请输入正确的URL', trigger: 'blur' }
        ],
        notifyOutstockUrl: [
          { type: 'url', message: '请输入正确的URL', trigger: 'blur' }
        ],
        notifyGoodsReturnUrl: [
          { type: 'url', message: '请输入正确的URL', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClose () {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('vendor/setappinfo', {
            payload: {
              vendorId: this.$route.query.vendorId,
              ...this.appInfo
            },
            success: (res) => {
              this.loading = false
              this.toggleModal(false)
              this.fetch && this.fetch()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
